parseFieldDefinition